import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { StockValuationScreen } from '@/features/inventory-analysis/stock-valuation-screen'
import {
  type StockValuationSearch,
  stockValuationSearchFrom,
} from '@/features/inventory-analysis/valuation-api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/stock-valuation')({
  validateSearch: (search: Record<string, unknown>): StockValuationSearch =>
    stockValuationSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: StockValuationRoute,
})

function StockValuationRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <StockValuationScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/inventory/reports/stock-valuation', search: next })
      }
    />
  )
}
